/**
 * Liquidity gap (FSD Part 3, 3.2.4; R038) — its own screen, moved out of the
 * forecast-accuracy report. The wiring packet spreads
 * `TREASURY_LIQUIDITY_GAP_ROUTES` beside `TREASURY_ROUTES`.
 *
 * Gated on `treasury.forecast.read`, which is what both
 * `GET /reports/liquidity-gap` and `GET /cash-forecast-runs/:id` declare.
 */

import type { RouteRecordRaw } from 'vue-router'

import { TREASURY_PERMISSIONS } from '@/modules/treasury/permissions'

export const TREASURY_LIQUIDITY_GAP_PATH = '/treasury/reports/liquidity-gap'

export const TREASURY_LIQUIDITY_GAP_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_LIQUIDITY_GAP_PATH,
    name: 'treasury-liquidity-gap',
    component: () => import('@/modules/treasury/liquidity-gap/LiquidityGapView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.liquidityGap',
      permission: TREASURY_PERMISSIONS.forecastRead,
    },
  },
]
